<template>
  <div class="subject-info-container">
    <!-- 申请主体信息标题 -->
    <h2 class="section-title">申请主体信息</h2>

    <!-- 主体信息内容区域 -->
    <div class="info-content">
      <!-- 农户信息 (identityType = 2) -->
      <div v-if="subjectInfo.identityType == 2" class="farmer-info-section">
        <!-- 第一行信息 -->
        <div class="info-row">
          <div class="info-item">
            <div class="info-label">姓名</div>
            <div class="info-value">{{ subjectInfo.name }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">手机号</div>
            <div class="info-value">{{ subjectInfo.contactPhone }}</div>
          </div>
        </div>

        <!-- 第二行信息 -->
        <div class="info-row">
          <div class="info-item">
            <div class="info-label">身份证号</div>
            <div class="info-value">{{ subjectInfo.creditCode }}</div>
          </div>
        </div>
      </div>

      <!-- 企业信息 (identityType = 4) -->
      <div v-else-if="subjectInfo.identityType == 4" class="company-info-section">
        <!-- 第一行信息 -->
        <div class="info-row">
          <div class="info-item">
            <div class="info-label">企业名称</div>
            <div class="info-value">{{ subjectInfo.name }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">统一社会信用代码</div>
            <div class="info-value">{{ subjectInfo.creditCode }}</div>
          </div>
        </div>

        <!-- 第二行信息 -->
        <div class="info-row">
          <div class="info-item">
            <div class="info-label">法定代表人</div>
            <div class="info-value">{{ subjectInfo.legalPerson }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">联系人</div>
            <div class="info-value">{{ subjectInfo.contactPerson }}</div>
          </div>
        </div>

        <!-- 第三行信息 -->
        <div class="info-row">
          <div class="info-item">
            <div class="info-label">联系电话</div>
            <div class="info-value">{{ subjectInfo.contactPhone }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">所在地</div>
            <div class="info-value">{{ subjectInfo.location }}</div>
          </div>
        </div>
      </div>

      <!-- 营业执照信息 (仅企业显示) -->
      <div v-if="subjectInfo.identityType == 4" class="license-section">
        <div class="info-label">营业执照</div>
        <el-image
          class="license-image"
          fit="contain"
          :src="photoBaseUrl + subjectInfo.businessLicenseUrl"
          :preview-src-list="[photoBaseUrl + subjectInfo.businessLicenseUrl]"
        ></el-image>
      </div>

      <!-- 身份证信息 (农户和企业都显示) -->
      <div class="id-card-section">
        <div class="info-label">{{ subjectInfo.identityType == 2 ? '身份证' : '法人身份证' }}</div>
        <div class="id-card-images">
          <el-image
            class="id-card-front"
            fit="contain"
            :src="photoBaseUrl + subjectInfo.idCardFrontUrl"
            :preview-src-list="[photoBaseUrl + subjectInfo.idCardFrontUrl]"
          ></el-image>
          <el-image
            class="id-card-back"
            fit="contain"
            :src="photoBaseUrl + subjectInfo.idCardBackUrl"
            :preview-src-list="[photoBaseUrl + subjectInfo.idCardBackUrl]"
          ></el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubjectInfoCard',
  data() {
    return {
      photoBaseUrl: window.globalUrl.BASE_API + 'admin/file/get?ossFilePath='
    }
  },
  props: {
    subjectInfo: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="less" scoped>
.subject-info-container {
  width: 100%;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  padding: 24px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  line-height: 28px;
  margin: 0 0 24px 0;
}

.info-content {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.farmer-info-section,
.company-info-section {
  width: 384px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}

.info-item {
  width: 184px;
}

.info-label {
  font-size: 14px;
  color: #6b7280;
  line-height: 20px;
  margin-bottom: 4px;
}

.info-value {
  font-size: 16px;
  font-weight: 500;
  color: #1f2937;
  line-height: 24px;
  word-break: break-all;
}

.license-section {
  width: 300px;
}

.license-image {
  margin-top: 24px;
  width: 200px;
  height: 152px;
  background-color: #f9fafb;
  position: relative;
}

.id-card-section {
  width: 384px;
}

.id-card-images {
  display: flex;
  gap: 16px;
  margin-top: 24px;
}

.id-card-front,
.id-card-back {
  background-color: #f9fafb;
  width: 180px;
  height: 113px;
  position: relative;
}

// 响应式设计
@media (max-width: 1280px) {
  .info-content {
    justify-content: center;
  }

  .farmer-info-section,
  .company-info-section,
  .license-section,
  .id-card-section {
    width: 100%;
    max-width: 500px;
  }
}

@media (max-width: 768px) {
  .subject-info-container {
    padding: 16px;
  }

  .section-title {
    font-size: 16px;
    margin-bottom: 16px;
  }

  .info-row {
    flex-direction: column;
    gap: 12px;
  }

  .info-item {
    width: 100%;
  }

  .id-card-images {
    flex-direction: column;
    align-items: center;
  }

  .id-card-front,
  .id-card-back {
    width: 100%;
    max-width: 250px;
  }
}
</style>
